import uuid from 'uuid';

export default function getCognitoId() {
  console.log('[getCognitoId] Generating a random string to use in IDP call');

  const newRandomString = uuid.v4();
  localStorage.setItem('cognitoId', newRandomString);
  return newRandomString;
}
